/* eslint-disable react/display-name */
/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

import { Avatar } from '~/_legacy/components/atoms/avatar/index';
import { ModalComment } from '~/_legacy/components/atoms/modal/comment';

import { CurrentUserState } from '~/state/currentUser';
import { media } from '~/utils';

export default function ({ org, corpFurusatoId, onSendReview }) {
  const currentUser = useRecoilValue(CurrentUserState);
  const [loaded, setLoaded] = React.useState(false);
  const [overlay, setOverlay] = React.useState(false);
  const [image, setImage] = React.useState(null);

  const ref = React.createRef();

  React.useEffect(() => {
    if (currentUser !== undefined) {
      setLoaded(true);
    }
  }, [currentUser]);

  if (!loaded) return <Wrapper />;

  const onClick = () => {
    setOverlay(true);
  };

  return (
    <div>
      <ImageInput
        ref={ref}
        onChange={(e) => {
          setImage(e.target && e.target.files[0]);
        }}
        type='file'
        accept='image/*'
      />
      <Wrapper onClick={onClick}>
        {overlay && (
          <ModalComment
            isVote={false}
            corpFurusatoId={corpFurusatoId}
            orgId={org && org.id}
            initialImage={image}
            onClose={() => {
              setOverlay(false);
              setImage(null);
            }}
            onSuccess={() => {
              setOverlay(false);
              onSendReview();
            }}
          />
        )}
        <Avatar size={'50px'} border={'1px solid #000'} src={currentUser && currentUser.image()} />
        <Review>
          クチコミで応援しよう
          <ImageIconWrapper
            onClick={(e) => {
              e.stopPropagation();

              if (ref.current && currentUser) ref.current.click();

              onClick();
            }}
          >
            <ImageIcon src='/images/image-icon.svg' />
          </ImageIconWrapper>
        </Review>
      </Wrapper>
    </div>
  );
}

const Wrapper = styled.div`
  padding: 0 35px;
  background: #fff;
  height: 80px;
  border-radius: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  ${media.mid`
    padding: 0 15px;
  `}
`;

const Review = styled.div`
  margin-left: 20px;
  height: 44px;
  flex: 1;
  border-radius: 22px;
  background: #ebebeb;
  font-size: 16px;
  color: #505050;
  line-height: 42px;
  padding-left: 15px;
  position: relative;

  ${media.mid`
    margin-left: 15px;
  `}
`;

const ImageIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background: #adadad;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 2px;
  top: 2px;
`;

const ImageIcon = styled.img``;

const ImageInput = styled.input`
  display: none;
`;
